import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateCompetitorIqWebsiteSettings as UpdateCompetitorIqWebsiteSettingsMutation,
    UpdateCompetitorIqWebsiteSettingsVariables as UpdateCompetitorIqWebsiteSettingsMutationVariables,
    CompetitorIqWebsitesSettingsInput,
} from 'nutshell-graphql-types';

import UPDATE_WEBSITE_SETTINGS from '../mutations/update-competitor-iq-website-settings.graphql';
import GET_WEBSITES from '../queries/get-competitor-iq-websites.graphql';

export const useUpdateCompetitorIqWebsites = (): {
    updateWebsiteSettings: (input: CompetitorIqWebsitesSettingsInput) => Promise<any>;
    isUpdating: boolean;
    error: string | null | undefined;
} => {
    const [updateWebsiteSettings, {loading, error}] = useMutation<
        UpdateCompetitorIqWebsiteSettingsMutation,
        UpdateCompetitorIqWebsiteSettingsMutationVariables
    >(UPDATE_WEBSITE_SETTINGS);

    return {
        updateWebsiteSettings: (input: CompetitorIqWebsitesSettingsInput) => {
            return updateWebsiteSettings({
                variables: {input},
                update: (proxy, mutationResults) => {
                    // Read the data from our cache for this query.
                    const cacheResult = proxy.readQuery({
                        query: GET_WEBSITES,
                    });

                    if (cacheResult) {
                        const updatedData =
                            mutationResults &&
                            mutationResults.data &&
                            mutationResults.data.competitorIqWebsitesSettingsSet;

                        if (!updatedData) return;

                        proxy.writeQuery({
                            query: GET_WEBSITES,
                            data: {competitorIqSettings: updatedData},
                        });
                    }
                },
            });
        },
        isUpdating: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
